import {hashHistory} from "react-router";
import uuid from "uuid";

import * as ActionTypes from '../../constants/actionTypes';
import {getNextMaxNumberFromList} from "../../utilities";
import {WIZARD_POPUP_TYPES} from "./wizardReducer";
import {loadingDialog_show, messageBox_Show} from "../../actions";
import {startWizardNode, defaultWizardItem} from "./WizardItem/wizardItemInterface";
import {getWizardListWithHashes} from "./wizardFunctions";
import {errorBox_Show} from "../../actions/A_Popups";

export const setWizardVisualizer = (wizardVisualizer) => ({
  type: ActionTypes.SET_WIZARD_VISUALIZER,
  payload: {wizardVisualizer}
});

export const setWizardList = (wizardList) => {
  // console.log("setWizardList setWizardList setWizardList", wizardList);
  return ({
    type: ActionTypes.SET_WIZARD_LIST,
    payload: {wizardList}
  })
};

export const setWizardListReceived = (wizardListReceived) => ({
  type: ActionTypes.SET_WIZARD_LIST_RECEIVED,
  payload: {wizardListReceived}
});

export const setWizardPendingList = (wizardPendingList) => ({
  type: ActionTypes.SET_WIZARD_PENDING_LIST,
  payload: {wizardPendingList}
});

export const setWizardPopupDisabledScenes = (wizardPopupDisabledScenes) => ({
  type: ActionTypes.SET_WIZARD_POPUP_DISABLED_SCENES,
  payload: {wizardPopupDisabledScenes: [...wizardPopupDisabledScenes]}
});

export const setWizardPopupEditToggles = (wizardPopupEditToggles) => ({
  type: ActionTypes.SET_WIZARD_POPUP_EDIT_TOGGLES,
  payload: {wizardPopupEditToggles}
});

export const setWizardPopupOpened = (wizardPopupOpened, wizardPopupType = WIZARD_POPUP_TYPES.sceneSelection) => ({
  type: ActionTypes.SET_WIZARD_POPUP_OPENED,
  payload: {wizardPopupOpened, wizardPopupType}
});

export const setWizardPopupItem = (wizardPopupItem, wizardPopupGroup = null) => ({
  type: ActionTypes.SET_WIZARD_POPUP_ITEM,
  payload: {
    wizardPopupItem: Object.assign({}, wizardPopupItem),
    wizardPopupGroup
  }
});

export const updateWizardPopupItem = (newWizardPopupItem) => ({
  type: ActionTypes.UPDATE_WIZARD_POPUP_ITEM,
  payload: {wizardPopupItem: Object.assign({}, newWizardPopupItem)}
});

export const setWizardPopupFiltersOpened = (wizardPopupFiltersOpened) => ({
  type: ActionTypes.SET_WIZARD_POPUP_FILTERS_OPENED,
  payload: {wizardPopupFiltersOpened}
});

export const setWizardPopupFiltersSearchText = (wizardPopupFiltersSearchText) => ({
  type: ActionTypes.SET_WIZARD_POPUP_FILTERS_SEARCH_TEXT,
  payload: {wizardPopupFiltersSearchText}
});
export const setWizardCloneLogic = (wizardCloneLogic) => ({
  type: ActionTypes.SET_WIZARD_CLONE_LOGIC,
  payload: {wizardCloneLogic}
});
export const setWizardFiltersLoading = (wizardFiltersLoading) => ({
  type: ActionTypes.SET_WIZARD_FILTERS_LOADING,
  payload: {wizardFiltersLoading}
});

export const fixStringEncoding = (string) => {
  return string && (typeof string === "string")
    ? string
      .replace("â€�", "”")
      .replace("â€", "”")
      .replace("â€™", "’")
      .replace("ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¨", "")
      .replace("Ã¢â‚¬Â¨", "") // not sure what it is
    : string
}

export const getEncodingFixedWizardItem = (wizItem) => {
  Object.keys(wizItem).forEach(property => {
    if (typeof wizItem[property] === "string") {
      wizItem[property] = fixStringEncoding(wizItem[property]);
    }
  });
  if (wizItem.wizardGroups) {
    wizItem.wizardGroups = wizItem.wizardGroups.map(wizGroup => {
      Object.keys(wizGroup).forEach(property => {
        if (typeof wizGroup[property] === "string") {
          wizGroup[property] = fixStringEncoding(wizGroup[property]);
        }
      })
      return wizGroup
    })
  }
  return wizItem
}

export const getWizardList = (wizardVisualizer, fabricatorId = null, getOnly = false, withAll = false) => {
  return async (dispatch, getState) => {
    dispatch(setWizardListReceived(false));
    if (!fabricatorId) {
      const {auth, asCustomer} = getState();
      fabricatorId =  asCustomer.data ? asCustomer.data.fabricatorId : auth.fabricatorId;
    }
    const wizVisualizerResponse = await getApiConfig('Wizard/Get/').get(fabricatorId + "/" + wizardVisualizer);
    let wizList = wizVisualizerResponse ? (JSON.parse(wizVisualizerResponse) || []) : [];
    if (withAll) {
      const wizVisualizerResponse = await getApiConfig('Wizard/Get/').get(fabricatorId + "/all");
      const allParsed = wizVisualizerResponse ? (JSON.parse(wizVisualizerResponse) || []) : [];
      wizList = [...wizList, ...allParsed]
    }
    wizList = wizList.map(wizItem => {
      wizItem.selected = false;
      wizItem = getEncodingFixedWizardItem(wizItem);
      if (!wizItem.uniqueHashId) {
        wizItem.uniqueHashId = uuid.v4();
      }
      return wizItem
    });
    console.log('response wizard-setup ->', wizList);
    if (getOnly) {
      return wizList
    }
    dispatch(setWizardList(wizList));
    dispatch(setWizardListReceived(true));
    return wizList
  }
};

export const saveWizardList = (wizardListArray, fabricatorId, saveOnly = false, forVisualizer = "") => {
  return (dispatch, getState) => {
    if (!saveOnly) {
      dispatch(loadingDialog_show(true, "Saving...", "Please wait while we are updating your changes."));
    }
    const {auth, asCustomer, wizardState} = getState();
    if (!fabricatorId) {
      fabricatorId = asCustomer.data ? asCustomer.data.fabricatorId : auth.fabricatorId;
    }
    const {wizardList, wizardVisualizer} = wizardState;
    if (!forVisualizer) {
      forVisualizer = wizardVisualizer
    }
    if (!wizardListArray) {
      wizardListArray = wizardList.filter(wizardItem => wizardItem.visualizer === forVisualizer);
    }
    wizardListArray = getWizardListWithHashes(wizardListArray);

    return getApiConfig('Wizard/Save').post(wizardListArray,  fabricatorId + "/" + forVisualizer)
      .then((response) => {
        console.log('response save wizard-setup ->', response);
        if (!saveOnly) {
          dispatch(loadingDialog_show(false));
        }
        return response
      })
      .catch((response) => {
        console.log('error save wizard-setup ->', response);
        dispatch(errorBox_Show({
          title: "Error",
          text: "Wizard save error",
        }));
        if (!saveOnly) {
          dispatch(loadingDialog_show(false));
        }
        return false
      });
  }
};

export const updateWizardList = (newWizardItem) => {
  return (dispatch, getState) => {
    const {wizardList} = getState().wizardState;
    dispatch(setWizardList(wizardList.map((wizardItem) => {
      if (wizardItem.uniqueHashId === newWizardItem.uniqueHashId) {
        return Object.assign({}, newWizardItem)
      }
      return wizardItem
    })));
  }
};

export const addNewWizardItem = () => {
  return (dispatch, getState) => {
    const {wizardList, wizardVisualizer} = getState().wizardState;
    const nextId = getNextMaxNumberFromList(wizardList, "id");
    const newItem = Object.assign({}, defaultWizardItem, {
      id: nextId,
      visualizer: wizardVisualizer,
      wizardNodes: [startWizardNode],
    });
    console.log("newItem", newItem);
    wizardList.push(newItem);
    dispatch(setWizardList([...wizardList]));
    return nextId
  }
};

export const copySelectedWizardItems = (selectedWizardItems = [], cloneToVisualizer = "", getWizardList) => {
  return async (dispatch, getState) => {
    const {auth, asCustomer, wizardState} = getState();
    const {wizardList} = wizardState;

    const fabricatorId = asCustomer.data ? asCustomer.data.fabricatorId : auth.fabricatorId;

    let wizList = cloneToVisualizer
      ? await getWizardList(cloneToVisualizer, fabricatorId, true)
      : [...wizardList];

    console.log("wizList", wizList);

    selectedWizardItems.forEach(selWizItem => {
      const nextId = getNextMaxNumberFromList(wizList, "id");
      const newItem = getEncodingFixedWizardItem(Object.assign({}, selWizItem, {
        id: nextId,
        uniqueHashId: uuid.v4(),
        name: selWizItem.name + " (copy)",
        selected: false,
        visualizer: cloneToVisualizer || selWizItem.visualizer,
      }));
      // console.log("newItem", newItem);
      wizList.push(newItem);
    })
    if (cloneToVisualizer) {
      await dispatch(saveWizardList(wizList, null, false, cloneToVisualizer));
      dispatch(setWizardVisualizer(cloneToVisualizer)); // go to the new one to update wiz list
    } else {
      dispatch(setWizardList(wizList));
    }
  }
};

export const cancelWizardGroupsChanges = (type = "") => {
  return dispatch => {
    dispatch(messageBox_Show(true, 'system', 'Cancel', 'Are you sure you want to cancel all unsaved changes?',
      [{
        text: 'Cancel',
        onClick: () => {
          dispatch(messageBox_Show());
        }
      }, {
        text: 'OK',
        onClick: () => {
          dispatch(messageBox_Show());
          switch (type) {
            case "discounts":
              dispatch({type: ActionTypes.DISCOUNTS_REVERT_CHANGES});
              break;
            default:
              dispatch({type: ActionTypes.WIZARD_PENDING_LIST_REVERT});
              hashHistory.push("/wizard");
              break;
          }
        }
      }]));
  }
};

export const setWizardNodeInputFocused = (wizardNodeInputFocused) => ({
  type: ActionTypes.SET_WIZARD_NODE_INPUT_FOCUSED,
  payload: {wizardNodeInputFocused}
});
